import ICONS from "../../../../../assets/Icons";
import globalText from "../../../../../utils/globalText";
import CommonLayout from "../../../../_utils/CommonLayout";
import CommonDestinationAccount from "../../../../_utils/TransactionCommonComponents/CommonDestinationAccount";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import SourceDestinationAccountDetail from "../../../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";

const InternalTransactionStepAccount = ({
  txnPayLoad,
  setTxnPayLoad,
  openOwner,
  setOpenOwner,
  isConfidential,
  setIsConfidential,
  shouldShowAssociatedAccounts,
  handleOwnerSelection,
  handleOpenInternalAccountModal,
  handleOpenAssociatedAccounts,
  associatedAccountsText,
}) => {
  return (
    <div className="w-width-full Qlg:px-padding-base px-padding-md py-padding-md max-w-tab-width-normal mx-auto">
      <CommonLayout>
        <SourceDestinationAccountDetail
          type="source"
          modalOpen={openOwner}
          setModalOpen={setOpenOwner}
          txnPayLoad={txnPayLoad}
          setTxnPayLoad={setTxnPayLoad}
          handleOnAccountSelection={handleOwnerSelection}
        />

        {/* dimming until a source is chosen is handled by
            CommonDestinationAccount (requiresSourceAccount) */}
        <div className="lg:flex-1 lg:max-w-[var(--create-box-width)] w-width-full lg:w-auto">
          <CommonDestinationAccount
            transactionPayload={txnPayLoad}
            setTransactionPayload={setTxnPayLoad}
            onSelectAccount={handleOpenInternalAccountModal}
            requiresSourceAccount
            showCreateAccount={false}
            showsBalance
            showAssociatedAccounts={shouldShowAssociatedAccounts}
            onViewAssociatedAccounts={handleOpenAssociatedAccounts}
            associatedAccountsText={associatedAccountsText}
          />
        </div>

        <ConfidentialCard
          icon={ICONS.CONFIDENTIAL_TRANSACTION}
          title={globalText?.CREATE_AS_CONFIDENTIAL}
          note={globalText?.CONFIDENTIAL_TRANSACTION_NOTE}
          toggleState={isConfidential}
          onToggle={() => setIsConfidential(!isConfidential)}
        />
      </CommonLayout>
    </div>
  );
};

export default InternalTransactionStepAccount;
